// src/index.ts
var DEFAULT_PAGINATION = {
  LIMIT: 10,
  PAGE: 1,
  ORDER: "desc"
};
var DURATION_WARNING = 600;
var MCP_STORAGE = "mcp_storage";
var MILLISECOND = 1e3;
var REFETCH_INTERVAL = 15e3;
var STALE_TIME = 5e3;
var SURVEYED_ID = "surveyedId";
export {
  DEFAULT_PAGINATION,
  DURATION_WARNING,
  MCP_STORAGE,
  MILLISECOND,
  REFETCH_INTERVAL,
  STALE_TIME,
  SURVEYED_ID
};
